<template>
<div>
    <v-app>
        <v-card elevation="0">
            <v-carousel
            cycle
            :show-arrows="true"
            :show-arrows-on-hover="true"
            :hide-delimiter-background="true"
            :hide-delimiters="true"
            height="auto"
            >
                <v-carousel-item v-for="(slide, index) in banners" :key="index">
                    <img :src="!isMobile() ? slide.desktop.imageUrl : slide.mobile.imageUrl">
                </v-carousel-item>
            </v-carousel>
        </v-card>
    </v-app>
</div>
</template>

<script>
import { isMobile } from '../helpers/helpers';
import{ VCarousel,VCarouselItem, VApp, VCard } from 'vuetify/lib';

export default {
  name: 'bannerSlideVantagens',
  props: {
      banners:{
        type: Array,
      },
  },
  methods: {
      isMobile
  },
  components: {
      VCarousel,
      VCarouselItem,
      VApp,
      VCard
  },
  created() {
      console.log('this.banners', this.type, this.banners);
  }
}
</script>

<style scoped lang="scss">
    .v-carousel {
        img {
            width: 100%;
            border-radius: 15px;
            min-height: 100px;
        }
    }
    
</style>
